// Define an array of fields that will be configured for the form
export const configuredFields = [
  'includePicture',
  'includeNote',
  'includeSignature',
  'includeAudio',
] as const
